import { useEffect, useState } from "react";
import API from "@/lib/api";

// PROVIDER-ONLY hook. Polls presence for a list of patient emails every 45s.
// Returns { email: last_seen_at_iso | null }. If enabled=false, returns {} and never calls.
export default function usePresenceByEmail(emails, enabled = true) {
  const [map, setMap] = useState({});

  useEffect(() => {
    if (!enabled) { setMap({}); return; }
    const unique = Array.from(new Set((emails || []).filter(Boolean)));
    if (!unique.length) { setMap({}); return; }

    let cancelled = false;
    const fetchNow = () => {
      API.post("/users/presence-by-email", { emails: unique })
        .then(({ data }) => { if (!cancelled) setMap(data || {}); })
        .catch(() => {});
    };
    fetchNow();
    const iv = setInterval(fetchNow, 45_000);
    return () => { cancelled = true; clearInterval(iv); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify((emails || []).slice().sort()), enabled]);

  return map;
}

// Helper: is last_seen considered "online now"?
export function isOnlineNow(lastSeenIso, windowSeconds = 120) {
  if (!lastSeenIso) return false;
  const t = Date.parse(lastSeenIso);
  if (!t) return false;
  return (Date.now() - t) / 1000 < windowSeconds;
}

// Helper: human-friendly "last seen" string.
export function lastSeenLabel(lastSeenIso) {
  if (!lastSeenIso) return "Never active";
  const t = Date.parse(lastSeenIso);
  if (!t) return "Never active";
  const diffSec = Math.floor((Date.now() - t) / 1000);
  if (diffSec < 120) return "Online now";
  if (diffSec < 3600) return `${Math.floor(diffSec / 60)}m ago`;
  if (diffSec < 86400) return `${Math.floor(diffSec / 3600)}h ago`;
  const days = Math.floor(diffSec / 86400);
  if (days < 7) return `${days}d ago`;
  return new Date(t).toLocaleDateString(undefined, { month: "short", day: "numeric" });
}
